import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios.ts';
import { type MutationConfig } from 'src/lib/react-query.ts';
import { formatResourcePath } from 'src/utils/regex.ts';

import type { Notification } from 'src/features/parkingManagement/types/notifications.ts';
import type { GeneralSmartParkError } from 'src/types/errors.ts';

interface DTO {
    parkingId: string;
    id: string;
}

const RESOURCE = '/parkings/:parkingId/parking-notification-settings/:id/';

type MutationFnType = typeof mutationFn;
const mutationFn = ({ parkingId, id, ...data }: DTO): Promise<Notification> => {
    return axios.patch(formatResourcePath(RESOURCE, { parkingId, id }), data);
};

interface UseMutationOptions extends MutationConfig<MutationFnType, GeneralSmartParkError> {}
const useMutationHook = (options: UseMutationOptions = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useUpdateNotificationSettings };
